import React, { useEffect } from "react";
import { BackButtonEvent, IonIcon, IonModal } from "@ionic/react";
import { StoriesSlider } from "./StoriesSlider/StoriesSlider";
import classNames from "classnames/bind";
import styles from "./StoriesModal.module.scss";
import { closeOutline, pauseOutline, play, volumeMedium, volumeMute } from "ionicons/icons";
import "./StoriesModal.scss";
import { useStoriesProviderData } from "../../providers/storiesProvider";
import { Capacitor } from "@capacitor/core";

const cx = classNames.bind(styles);

const StoriesModal = () => {
  const {
    resetStoriesState,
    toggleSliderPlaying,
    isPlaying,
    setIsModalOpened,
    isModalOpened,
    activeVideo,
    isVideoMuted,
    toggleVideoVolume,
    isSliderLoading,
  } = useStoriesProviderData();

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      const handleBackButton = (ev: BackButtonEvent) => {
        ev.detail.register(100, () => {
          if (isModalOpened) {
            setIsModalOpened();
          }
        });
      };

      document.addEventListener("ionBackButton", handleBackButton as EventListener);

      return () => {
        document.removeEventListener("ionBackButton", handleBackButton as EventListener);
      };
    }
  }, [isModalOpened, setIsModalOpened]);

  return (
    <IonModal
      mode={"ios"}
      className={"stories-modal"}
      onDidDismiss={() => {
        resetStoriesState();
      }}
      isOpen={isModalOpened}
    >
      <span className={cx("button")} onClick={() => setIsModalOpened()}>
        <IonIcon className={cx("icon")} icon={closeOutline} />
      </span>
      <span
        className={cx("button", "button__play")}
        onClick={() => {
          if (isSliderLoading) return;
          toggleSliderPlaying();
        }}
      >
        {isPlaying ? (
          <IonIcon className={cx("icon")} icon={pauseOutline} />
        ) : (
          <IonIcon className={cx("icon")} icon={play} />
        )}
      </span>
      {activeVideo ? (
        <span className={cx("button", "button__volume")} onClick={toggleVideoVolume}>
          {isVideoMuted ? (
            <IonIcon className={cx("icon")} icon={volumeMute} />
          ) : (
            <IonIcon className={cx("icon")} icon={volumeMedium} />
          )}
        </span>
      ) : null}
      <StoriesSlider />
    </IonModal>
  );
};

export { StoriesModal };
